import React, { useState, useEffect, useCallback, Component } from 'react';
import Modals from 'components/v2/Modals.js';
import KeyListener from 'components/KeyListener.js';
import Scripting from 'scripting/Scripting.js';
import {DOCUMENTATION_MAP} from './constants.js';
import ScriptableSequencer from 'engine/ScriptableSequencer.js';
import KeyboardEngine from 'keyboard/KeyboardEngine.js';

const DocumentationViewer = (props) => {
    let [sequencerEngine, setSequencerEngine] = useState(undefined); 
    let [keyListener, setKeyListener] = useState(undefined); 
    useEffect(() => {
        let sequencerEngine = new ScriptableSequencer(props.store);
        sequencerEngine.loadSequence(
            'QmPSQ6BCyBxNFNTFpJFmrbxYKZQn5ibjdqZC7p3kFC9oUU');
        let scripting = new Scripting(sequencerEngine);
        sequencerEngine.setScripting(scripting);
        let keyboardEngine = new KeyboardEngine(sequencerEngine);
        sequencerEngine.connectToKeyboardEngine(keyboardEngine);
        let keyListener = new KeyListener(sequencerEngine);
        setSequencerEngine(sequencerEngine);
        setKeyListener(keyListener);
        window.sequencerEngine = sequencerEngine;

        window.addEventListener('keydown', keyListener.onKeyDown);
        window.addEventListener('keyup', keyListener.onKeyUp);

        return () => {
            window.removeEventListener('keydown', keyListener.onKeyDown);
            window.removeEventListener('keyup', keyListener.onKeyUp);
        };
    },[]);

    useEffect(() => {
        window.scrollTo(0,0);
    }, [props.toShow]);

    let className = "doc-viewer";
    if (!sequencerEngine) {
        return [];
    }
    if (props.toShow === "Midi Effects") {
        className += " wide midi-effects-viewer";
    }
    return (
        <div className={className}>
          <div color="radial-gradient(75.29% 75.29% at 64.96% 24.36%, #F0DFA7 0.52%, #FDBDAA 18.75%, #FEA186 34.38%, #F09277 49.48%, #D27584 74.48%, #6B7B8A 100%)" className="coke-machine-glow"/>
          <Modals sequencerEngine={sequencerEngine}/>
          <div className="header">
            {props.toShow}
              </div>
          {DOCUMENTATION_MAP[props.toShow](sequencerEngine, props.goToLink)}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
    }
};

export default DocumentationViewer;
